import { components } from 'react-select';

import { ClearIndicatorProps } from './ClearIndicator.types';
import { CircleX } from '../../../../../icons';

export const ClearIndicator = ({ ...rest }: ClearIndicatorProps) => {
  const hasValue = Boolean(rest.getValue()[0]);

  if (!hasValue) {
    return null;
  }

  return (
    <components.ClearIndicator {...rest} className="!cursor-pointer">
      <CircleX
        data-testid="close-circle-icon"
        className="size-5 stroke-primary-400"
        aria-label="Clear option"
      />
    </components.ClearIndicator>
  );
};
